import React, { useState } from 'react';
import useContracts from '../sales-page/hooks/useContracts';
import DiamondCard from './DiamondCard';
import './DiamondShowcase.css';

const INITIAL_VISIBLE = 3;

const DiamondShowcase = () => {
    const { contracts, loading, error } = useContracts();
    const [showAll, setShowAll] = useState(false);
    const [revealing, setRevealing] = useState(false);

    if (loading || error) return null;

    const visibleContracts = showAll ? contracts : contracts.slice(0, INITIAL_VISIBLE);
    const hasMore = contracts.length > INITIAL_VISIBLE;

    const handleReveal = () => {
        setRevealing(true);
        setTimeout(() => {
            setShowAll(true);
            setRevealing(false);
        }, 1400);
    };

    return (
        <section className="diamond-showcase-section">
            <div className="diamond-showcase-container">
                <div className="diamond-showcase-header">
                    <h2 className="diamond-showcase-title">Nossas Oportunidades Exclusivas</h2>
                    <p className="diamond-showcase-subtitle">
                        Invista em Diamantes e receba 2% de Cashback todo mês na sua conta.
                    </p>
                </div>

                <div className="diamond-grid">
                    {visibleContracts.map((contract, idx) => (
                        <div
                            key={contract.id}
                            className={`diamond-grid-item ${showAll && idx >= INITIAL_VISIBLE ? 'diamond-grid-item--revealed' : ''}`}
                            style={showAll && idx >= INITIAL_VISIBLE ? { animationDelay: `${(idx - INITIAL_VISIBLE) * 80}ms` } : undefined}
                        >
                            <DiamondCard contract={contract} />
                        </div>
                    ))}
                </div>

                {hasMore && !showAll && (
                    <div className="diamond-showcase-cta-wrapper">
                        <button
                            className={`diamond-showcase-cta ${revealing ? 'is-loading' : ''}`}
                            onClick={handleReveal}
                            disabled={revealing}
                        >
                            {revealing ? (
                                <span className="diamond-showcase-cta-loading">
                                    <span className="diamond-loader" aria-hidden="true">
                                        <span className="diamond-loader-shape"></span>
                                    </span>
                                    <span>Carregando curadoria...</span>
                                </span>
                            ) : (
                                <>
                                    <span>Veja nossa curadoria completa</span>
                                    <svg className="diamond-showcase-cta-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default DiamondShowcase;
